var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92632 19.444H16.2967C17.524 19.444 18.5189 18.4491 18.5189 17.2218V7.97607C18.5189 7.45123 18.3332 6.94333 17.9945 6.54233L15.481 3.56583C15.0588 3.06582 14.4376 2.77734 13.7832 2.77734H5.92632C4.69902 2.77734 3.7041 3.77227 3.7041 4.99957V17.2218C3.7041 18.4491 4.69902 19.444 5.92632 19.444Z",
    stroke: "#3E556D",
    strokeWidth: 1.38889
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3516 2.77734V6.01808C14.3516 7.04083 15.1807 7.86994 16.2034 7.86994H18.5182",
    stroke: "#3E556D",
    strokeWidth: 1.38889
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40723 11.1108H14.8146",
    stroke: "#3E556D",
    strokeWidth: 1.38889,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40723 8.33301H9.25908",
    stroke: "#3E556D",
    strokeWidth: 1.38889,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.219e422a50ceeca2d87ec8a8d79dc3a4.svg";
export { ForwardRef as ReactComponent };